import { render, staticRenderFns } from "./SecondStepDocumentIntrare.vue?vue&type=template&id=2486bc2d&scoped=true&"
import script from "./SecondStepDocumentIntrare.ts?vue&type=script&lang=ts&"
export * from "./SecondStepDocumentIntrare.ts?vue&type=script&lang=ts&"
import style0 from "./SecondStepDocumentIntrare.vue?vue&type=style&index=0&id=2486bc2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2486bc2d",
  null
  
)

export default component.exports
import {QBtn,QSpinnerGears,QField} from 'quasar'
component.options.components = Object.assign({QBtn,QSpinnerGears,QField}, component.options.components || {})
